import { render, staticRenderFns } from "./AssetApiKey.vue?vue&type=template&id=63c19ff6&scoped=true&"
import script from "./AssetApiKey.vue?vue&type=script&lang=ts&"
export * from "./AssetApiKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c19ff6",
  null
  
)

export default component.exports